import { useMutation } from '@tanstack/react-query';
import LangEnum from '../../lang/LangEnum';
import snackbarStore from '../../stores/Snackbar.store';
import { useTranslation } from '../translation/TranslationContext';
import posRepository from './pos.repository';
import { CreatePosBody } from './pos.types';

export const useCreatePosMutation = () => {
  const { translate } = useTranslation();
  const { handleMessage } = snackbarStore;

  const { isPending, mutate: createPos } = useMutation({
    mutationFn: async (body: CreatePosBody) => {
      const response = await posRepository.createPos(body);
      if (!response.ok) {
        throw response.originalError ?? new Error('createPos failed');
      }
    },
    onSuccess: () => {
      handleMessage({
        type: 'success',
        message: translate(LangEnum.GLOBAL_SUCCESS_ON_CREATE_USER_ANSWER),
      });
    },
    onError: () => {
      handleMessage({
        type: 'error',
        message: translate(LangEnum.GLOBAL_ERROR_ON_SEND_ANSWER_AND_RETRY_MESSAGE),
      });
    },
  });

  return { createPos, isPending };
};
